import type { TModernMetrics } from '@modern/theme/modern-theme.types';

export const metricsBaseTheme: TModernMetrics = {
  control: {
    height: '2rem',
    heightSmall: '1.75rem',
  },
  radius: '0',
};
